import { render } from "./pharmacyheader.vue?vue&type=template&id=695f2a2e"
import script from "./pharmacyheader.vue?vue&type=script&lang=js"
export * from "./pharmacyheader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__